
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorDeInicio } from './controlador';
    import Jquery from 'jquery';
    import cuenta from './control-bultos-cuenta.vue';
    import noexiste from './control-bultos-no-existe.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            noexiste,
            cuenta,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public ControladorPrincipal: ControladorDeInicio;

        @Prop()
        public Controlador: ControladorDeInicio;

        public get Bultos() { return this.Controlador.Bultos; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public UltimaBusqueda: string = '';
        public Buscando: boolean = false;
        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            if ( this.Busqueda.length >= 9 )
            {
                await this.BuscarBulto();
            }
        }

        public async BuscarBulto()
        {
            this.Buscando = true;
            let e = this.Busqueda;
            this.Busqueda = '';
            this.UltimaBusqueda = e;
            await this.Controlador.BuscarBulto( e );
            this.Buscando = false;
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
            clearInterval( this.Intervalo );
        }

        public Intervalo: any = null;
        mounted()
        {
            
            this.Intervalo = setInterval( () =>
            {
                if ( !this.Buscando )
                {
                    Jquery( '#input-bulto' ).focus();
                }
                
            }, 5000 );
            
        }

        public async Cancelar()
        {
            this.Controlador.Cancelar();
            this.ControladorPrincipal.Vista.Modo = 'menu';
        }

        public async Controlar()
        {
            if ( this.Bultos.hasRows() )
                await this.Controlador.Siguiente();

        }
    }
